import request  from '@/utils/request'
import qs from 'qs'

// 订单时间
export const getYear = () => {
    return request({
      url: '/api/lab/getYear',
      method: 'GET'
    })
}
// 检测分类
export const getEnterpriseClass = params => {
    return request({
      url: '/api/enterprise/classification',
      method: 'POST',
      data: params
    })
}

// 订单数据统计
export const getOrderDataStatic = (params) => {
    return request({
      url: '/api/enterprise/dataStatistics',
      method: 'POST',
      data: params
    })
}

// 实验室数据统计
export const getLabDataStatic = (params) => {
    return request({
      url: '/api/enterprise/labDataStatistics',
      method: 'POST',
      data: params
    })
}

// 企业用户数据统计
export const getCompanyUserStatic = (params) => {
    return request({
      url: '/api/enterprise/statistics',
      method: 'POST',
      data: params
    })
}



// 管理员查看企业列表
export const getCompanyList = () => {
    return request({
      url: '/api/enterprise/showEnterprise',
      method: 'GET'
    })
}

// 筛选实验室
export const getLabList = () => {
    return request({
      url: '/api/enterprise/showScreeningLab',
      method: 'GET'
    })
}